import {orderBy} from 'external/lodash'
import {useEffect, useState} from 'external/react'
import {
   styled
  ,Fade
  ,Box
  ,Paper
} from 'external/material'

import useTranslations from 'hooks/translations'
import useAssessment from 'hooks/assessment'
import useSession from 'hooks/session'

import Timer from './Timer'
import Navigation from './Navigation'
import Sections from './Sections'
import Section from './Section'
import Question from './Question'

import FinalizeAssessment from './FinalizeAssessment'

import FullScreenDialog from 'components/FullScreenDialog'

const StyledAssessment = styled(Box)(assessmentStyles)
 
export default function Assessment () {


    const {translate} = useTranslations()
    const {assessmentId, sectionId, questionId, navigation} = useSession()
    const {assessment = {}, assessmentLoaded, getType} = useAssessment() 
    const {type, title} = assessment.content || {}
    const [finalizeIsOpen, openFinalize] = useState(false)

    const typeName = translate(getType(type))
    const sections = assessmentLoaded
      ? orderBy(Object.values(assessment.content.sections || {}),'index')
      : []

    useEffect(() => {
      if (assessmentId && assessmentLoaded && !sectionId && sections.length > 0) {
        const [{id}] = sections
        navigation.assessmentSection.go({sectionId: id})
      }
    }, [assessmentLoaded])

    const isSection = !questionId

    const shouldDisplay = assessmentLoaded && assessmentId != undefined && sectionId != undefined
    
    function handleClose() {
      navigation.section.go({section: 'assessment'})
    }

    return (
        <FullScreenDialog open={shouldDisplay} handleClose={handleClose} >
          <StyledAssessment>
            {shouldDisplay && (<>
            <FinalizeAssessment isOpen={finalizeIsOpen} onClose={() => openFinalize(false)}/>
            <Paper className="view">
              <Box className="viewHeader">
                <Box className="type">{typeName}:</Box>
                <Box className="title">{title}</Box>
              </Box>
              <Box className="viewContent">
                {isSection && (<Section sections={sections} />)}
                {!isSection && (<Question sections={sections} />)} 
              </Box>
              <Box className="viewNavigation">
                <Navigation sections={sections} openFinalize={() => openFinalize(true)} />
              </Box>
            </Paper>
            <Box className="side">
              <Timer />
              <Sections sections={sections} />
            </Box>
            </>)}
          </StyledAssessment>
        </FullScreenDialog>
    )
}


export function assessmentStyles () {
  return {
    display: 'flex',
    padding: 10,
    flexGrow: 1,
    overflow: 'hidden',
    "& .view": {
      flexGrow: 1,
      overflowY: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
    "& .viewHeader": {
      display: 'flex',
      color: '#4d5361',
      fontSize:'13pt',
      padding: 20,
      borderBottom: 'solid 1px #d3d8db',
      "& .type": {
        fontWeight: 'bold'
      },
      "& .title": {
        marginLeft: 3
      }
    },
    "& .viewContent": {
      display: 'flex',
      flexGrow: 1,
      overflowY: 'hidden',
    },
    "& .viewNavigation": {
      borderTop: 'solid 1px #d3d8db',
      padding: 20
    },
    "& .side": {
      marginLeft: 25,
      display: 'flex',
      flexDirection: 'column',
      minWidth: 255,
      maxWidth: 255
    },
  }
}
